<template>
  <div class="pl-3 pr-3 mb-5">
    <PageTitle title="Cadastro de produtos" />

    <b-row class="mt-3">
      <b-col cols="12" class="mt-4">
        <table class="table">
          <thead class="letter-orange">
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Código</th>
              <th scope="col">Marca</th>
              <th scope="col">Código extra</th>
              <th scope="col">Documento qtd.</th>
              <th scope="col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in products" v-bind:key="item.id">
              <th scope="row">
                {{ item.name }}
              </th>
              <td>
                {{ item.code }}
              </td>
              <td>
                {{ item.mark }}
              </td>
              <td>
                {{ item.code_bel }}
              </td>
              <td>
                {{ item.files.length }}
              </td>
              <td>
                <div class="btn btn-primary mr-1" @click="addFileProduct(item)">
                  <i class="fas fa-plus" aria-label="Add. documento"></i>
                </div>
                <div class="btn btn-danger" @click="delError(item.id)">
                  <i class="fas fa-trash-alt" aria-label="Excluir"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <b-modal
      title="Adicionar PDF ao produto"
      size="xl"
      id="modalFiles"
      no-close-on-backdrop
      ok-only
      centered
      hide-footer
      header-bg-variant="orange"
    >
      <div class="row">
        <div class="col-6">
          <label>Nome do aquivo</label>
          <input
            type="text"
            class="form-control"
            v-model="form.name"
            placeholder="Insira o nome do arquivo"
          />
        </div>

        <div class="col-6">
          <label>Url arquivo pdf</label>
          <input type="text" v-model="form.file" class="form-control" />
        </div>

        <div class="col-12 text-center mt-3">
          <button class="btn btn-success pr-5 pl-5" @click="saveFile()">
            Salvar
          </button>
        </div>

        <div class="col-12 mt-3">
          <table class="table mt-4">
            <thead class="letter-orange">
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Url</th>
                <th scope="col">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in files" :key="i">
                <th scope="row">
                  {{ item.name }}
                </th>
                <td>
                  {{ item.file }}
                </td>
                <td>
                  <div class="btn btn-danger" @click="delDocument(item.id, i)">
                    <i class="fas fa-trash-alt" aria-label="Excluir"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import { mapState } from 'vuex';

export default {
  components: {
    PageTitle,
  },

  mixins: [makeToast],

  data() {
    return {
      loading: false,
      products: [],
      files: [],
      form: {
        products_id: null,
        name: '',
        file: '',
      },
    };
  },

  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },

  mounted() {
    this.get();
  },
  methods: {
    get() {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/getProductsBel', this.dadosUsuario.id)
        .then((res) => {
          this.products = res.data;
        })
        .catch(() => {
          this.makeToast(
            'Erro!',
            'Ocorreu um erro, favor recarregar a página!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },

    saveFile() {
      if (this.form.name == '' || this.form.file == '') {
        this.makeToast(
          'Atenção!',
          'Os campos nome, e url, são obrigatórios!',
          'warning'
        );
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/newFileProductBell', this.form)
        .then((response) => {
          this.$store.dispatch('endLoader');
          if (response.data.error) {
            this.makeToast('Erro!', response.data.message, 'danger');
            return;
          }

          this.makeToast('Sucesso', response.data.message, 'success');
          this.$bvModal.hide('modalFiles');
          this.defaultForm();
          this.get();
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Erro!', 'Ocorreu um erro', 'danger');
        });
    },

    delError(id) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/dellProductsBel', id)
        .then((response) => {
          this.$store.dispatch('endLoader');
          if (response.data.error) {
            this.makeToast('Erro!', response.data.message, 'danger');
            return;
          }

          this.makeToast('Sucesso', response.data.message, 'success');
          this.defaultForm();
          this.get();
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Erro!', 'Ocorreu um erro', 'danger');
        });
    },
    delDocument(id, i) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/dellProductFileBel', id)
        .then((response) => {
          this.$store.dispatch('endLoader');
          if (response.data.error) {
            this.makeToast('Erro!', response.data.message, 'danger');
            return;
          }

          this.makeToast('Sucesso', response.data.message, 'success');
          this.files.splice(i, 1);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Erro!', 'Ocorreu um erro', 'danger');
        });
    },
    addFileProduct(item) {
      this.defaultForm();
      this.files = item.files;
      this.form.products_id = item.id;

      this.$bvModal.show('modalFiles');
    },
    defaultForm() {
      this.form.products_id = null;
      this.form.name = '';
      this.form.file = '';
    },
  },
};
</script>
